import React from 'react'
import { Plus } from 'lucide-react'

interface AddColumnButtonProps {
  onClick: () => void
  className?: string
}

export const AddColumnButton: React.FC<AddColumnButtonProps> = ({ onClick, className = '' }) => {
  return (
    <button
      onClick={onClick}
      className={`btn btn-primary ${className}`}
    >
      <Plus className="icon" />
      <span>列を追加</span>
    </button>
  )
} 